export enum FormKeys {
    OrderAwaitingAcceptance = 'orderAwaitingAcceptance',
    OrderAccepted = 'orderAccepted',
}
